import * as yup from 'yup';

export interface FormValues {
  name: string;
  description: string | null;
}

export const COPY_PLAN_FORM_ID = 'plan-selection--copy-plan-form';

export const EDIT_PLAN_FORM_ID = 'plan-selection--edit-plan-form';

export const NEW_PLAN_FORM_ID = 'plan-selection--new-plan-form';

export const validation = yup.object().shape({
  name: yup.string().required('Please enter a plan name'),
});
